// meta.error_type values the CliqForms API returns for CliqSign problems (BridgeRequestException).
export const ESIGN_ERRORS = {
  NOT_AVAILABLE: 'esign_not_available'
}

// Why "Send agreement" on a Submission is blocked: the API's SendOptions blocked_reason values.
export const SEND_BLOCKED_REASONS = {
  AGREEMENT_ACTIVE: 'agreement_active',
  SUBMISSION_ARCHIVED: 'submission_archived'
}
